import type { List } from 'fhir/r4';
import { defineStore } from 'pinia';

export const useUserStore = defineStore('userStore', {
  state: () => {
    return {
      usrId: '', //id of FHIR resource representing user
      usrRole: '',
      usrPermissions: {
        viewTrials: false,
        changeTrialInfo: false,
        changeTrialInfoAdvanced: false, //Permission to change normally unchangeable info, e.g. study identifier
        viewChangeHistory: false,
        confirmChanges: false,
        createTrials: false,
        deleteTrials: false,
      },
      usrFavouriteStudies: undefined as undefined | List,
    };
  },
});
